import { IcosHeader } from './header'
import { IcosAside } from './aside'
import { IcosMain } from './main'
import { IcosFooter } from './footer'

export {
  IcosMain,
  IcosAside,
  IcosHeader,
  IcosFooter,
}
